class DashboardService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getDashboard() {
    return this.apiService.get('/api/v1/dashboard');
  }
  getReportsDashboard() {
    return this.apiService.get('/api/v1/reports/dashboard');
  }
  getOneDashboard() {
    return this.apiService.get('/api/v1/one/dashboard');
  }
}

export default DashboardService;
